import {
  Add,
  ArrowDropDown,
  Close,
  FilterAltOutlined,
  Key,
  KeyOutlined,
  Verified,
  WatchLater,
} from "@mui/icons-material";
import {
  Badge,
  Box,
  Button,
  Grid,
  Menu,
  MenuItem,
  Paper,
  Typography,
  useTheme,
  Tooltip,
  Stack,
  Modal,
  DialogTitle,
  IconButton,
  DialogContent,
  TextField,
  InputAdornment,
  DialogActions,
} from "@mui/material";

import "dayjs/locale/pt-br";
import { useMemo, useState } from "react";
import useStyles from "./styles";
import { StatusOption } from "../types";

interface FiltersProps {
  verifyStatus: StatusOption;
  setVerifyStatus: React.Dispatch<React.SetStateAction<StatusOption>>;
  permissionStatus: StatusOption;
  setPermissionStatus: React.Dispatch<React.SetStateAction<StatusOption>>;
  handleNewOpen: () => void;
}

interface ModalFilterMobileProps {
  openModal: boolean;
  setOpenMobileModal: React.Dispatch<React.SetStateAction<boolean>>;
  verifyStatus: StatusOption;
  setVerifyStatus: React.Dispatch<React.SetStateAction<StatusOption>>;
  permissionStatus: StatusOption;
  setPermissionStatus: React.Dispatch<React.SetStateAction<StatusOption>>;
}

interface ModalPermissionProps {
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
  setPermissionStatus: (status: StatusOption) => void;
}

interface ModalVerifyProps {
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
  setVerifiedStatus: React.Dispatch<React.SetStateAction<StatusOption>>;
}
const ModalPermission: React.FC<ModalPermissionProps> = ({
  anchorEl,
  setAnchorEl,
  setPermissionStatus,
}) => {
  const handleClose = (status: StatusOption | null) => {
    setAnchorEl(null);
    if (status) setPermissionStatus(status);
  };

  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={() => handleClose(null)}
      MenuListProps={{ "aria-labelledby": "basic-button" }}
    >
      <MenuItem onClick={() => handleClose({ value: "", label: "" })}>
        Nenhum
      </MenuItem>
      <MenuItem
        onClick={() => handleClose({ value: "adm002", label: "Admin" })}
      >
        Admin
      </MenuItem>
      <MenuItem
        onClick={() => handleClose({ value: "adm001", label: "Super Admin" })}
      >
        Super Admin
      </MenuItem>
      <MenuItem
        onClick={() => handleClose({ value: "user001", label: "Usuário" })}
      >
        Usuário
      </MenuItem>
    </Menu>
  );
};

const ModalVerify: React.FC<ModalVerifyProps> = ({
  anchorEl,
  setAnchorEl,
  setVerifiedStatus,
}) => {
  const handleClose = (status: StatusOption | null) => {
    setAnchorEl(null);

    if (status) {
      setVerifiedStatus(status);
    }
  };

  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={() => handleClose(null)}
      MenuListProps={{ "aria-labelledby": "basic-button" }}
    >
      <MenuItem onClick={() => handleClose({ value: "", label: "" })}>
        Nenhum
      </MenuItem>
      <MenuItem onClick={() => handleClose({ value: true, label: "Ativo" })}>
        Ativo
      </MenuItem>
      <MenuItem
        onClick={() => handleClose({ value: false, label: "Aguardando" })}
      >
        Aguardando
      </MenuItem>
    </Menu>
  );
};

const ModalFiltersMobile: React.FC<ModalFilterMobileProps> = (props) => {
  const {
    openModal,
    setOpenMobileModal,
    verifyStatus,
    setVerifyStatus,
    permissionStatus,
    setPermissionStatus,
  } = props;
  const theme = useTheme();
  const styles = useStyles(theme);
  const handleClose = () => {
    setOpenMobileModal(false);
    setPermissionStatus({ label: "", value: "" });
    setVerifyStatus({ label: "", value: "" });
  };

  const handleClearFilters = () => {
    setPermissionStatus({ label: "", value: "" });
    setVerifyStatus({ label: "", value: "" });
  };
  return (
    <Modal open={openModal} onClose={handleClose} sx={styles.modal}>
      <Paper sx={styles.paper}>
        <DialogTitle color="primary" sx={styles.dialogTitle}>
          <Box sx={styles.boxHeader}>
            <IconButton size="small">
              <FilterAltOutlined sx={{ color: "primary.main" }} />
            </IconButton>
            <Typography fontWeight={500}>Filtros:</Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={styles.dialogContent}>
          <Grid container columnSpacing={1.5} rowSpacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Box sx={styles.boxRowFields}>
                <TextField
                  select
                  label="Status"
                  variant="filled"
                  value={verifyStatus.value}
                  onChange={(e) =>
                    setVerifyStatus({ value: e.target.value, label: "" })
                  }
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <IconButton size="small" edge="start">
                            <Verified sx={styles.iconTextFields} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                >
                  <MenuItem value="">Nenhum</MenuItem>
                  <MenuItem value="true">Ativo</MenuItem>
                  <MenuItem value="false">Aguardando</MenuItem>
                </TextField>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Box sx={styles.boxRowFields}>
                <TextField
                  select
                  label="Permissão"
                  variant="filled"
                  value={permissionStatus.value}
                  onChange={(e) =>
                    setPermissionStatus({ value: e.target.value, label: "" })
                  }
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <IconButton size="small" edge="start">
                            <KeyOutlined sx={styles.iconTextFields} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                >
                  <MenuItem value="">Nenhum</MenuItem>
                  <MenuItem value={"adm001"}>Super Admin</MenuItem>
                  <MenuItem value={"adm002"}>Admin</MenuItem>
                  <MenuItem value={"user001"}>Usuário</MenuItem>
                </TextField>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={styles.dialogActions}>
          <Button
            sx={{ textTransform: "none", color: "primary.main" }}
            onClick={() => {
              handleClearFilters();
            }}
            variant="text"
          >
            Limpar Filtros
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setOpenMobileModal(false);
            }}
            sx={styles.buttonModalMobileFilters}
          >
            Aplicar
          </Button>
        </DialogActions>
      </Paper>
    </Modal>
  );
};

const Filters: React.FC<FiltersProps> = (props) => {
  const {
    verifyStatus,
    setVerifyStatus,
    permissionStatus,
    setPermissionStatus,
    handleNewOpen,
  } = props;
  const [anchorElVerify, setAnchorElVerify] = useState<null | HTMLElement>(
    null
  );

  const [anchorElPermission, setAnchorElPermission] =
    useState<null | HTMLElement>(null);
  const [openMobileModal, setOpenMobileModal] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);

  const handleClick = (
    event: React.MouseEvent<HTMLElement>,
    filterType: "verify" | "permission"
  ) => {
    if (filterType === "verify") {
      setAnchorElVerify(event.currentTarget);
    } else {
      setAnchorElPermission(event.currentTarget);
    }
  };

  const handleCleanFilters = () => {
    setPermissionStatus({ value: "", label: "" });
    setVerifyStatus({ value: "", label: "" });
  };

  const filtersCount = useMemo(() => {
    let count = 0;
    if (verifyStatus.value.toString()) count += 1;
    if (permissionStatus.value.toString()) count += 1;
    return count;
  }, [verifyStatus, permissionStatus]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          width: { xs: "fit-content", md: "100%" },
          justifyContent: "space-between",
        }}
      >
        <Box sx={styles.backgroundBox}>
          <Grid container rowSpacing={2} spacing={1}>
            <Grid>
              <Box sx={styles.boxTitle}>
                <FilterAltOutlined sx={styles.size} />
                <Typography sx={styles.text}>{"Filtros:"}</Typography>
              </Box>
            </Grid>

            <Grid>
              <Paper
                //variant="brick"
                sx={styles.paperBrick}
                onClick={(e) => handleClick(e, "verify")}
              >
                <Stack sx={{ display: "flex", flexDirection: "row", gap: 0.5 }}>
                  <Typography sx={styles.text}>Status:</Typography>
                  {verifyStatus?.label === "Ativo" ? (
                    <Verified sx={[styles.size, { color: "success.main" }]} />
                  ) : verifyStatus?.label === "Aguardando" ? (
                    <WatchLater
                      sx={[styles.size, { color: "text.secondary" }]}
                    />
                  ) : null}

                  <Typography
                    sx={styles.text}
                    color={
                      verifyStatus?.label === "Ativo"
                        ? "success.main"
                        : "text.secondary"
                    }
                  >
                    {verifyStatus?.label}
                  </Typography>
                </Stack>
                <ArrowDropDown sx={styles.size} />
              </Paper>
              <ModalVerify
                anchorEl={anchorElVerify}
                setAnchorEl={setAnchorElVerify}
                setVerifiedStatus={setVerifyStatus}
              />
            </Grid>

            <Grid>
              <Paper
                //variant="brick"
                sx={styles.paperBrick}
                onClick={(e) => handleClick(e, "permission")}
              >
                <Key sx={styles.size} />
                <Typography
                  sx={styles.text}
                >{`Permissão: ${permissionStatus?.label}`}</Typography>
                <ArrowDropDown sx={styles.size} />
              </Paper>
              <ModalPermission
                anchorEl={anchorElPermission}
                setAnchorEl={setAnchorElPermission}
                setPermissionStatus={setPermissionStatus}
              />
            </Grid>

            {verifyStatus.label || permissionStatus.label ? (
              <Grid>
                <Box sx={styles.boxTitle}>
                  <Button
                    sx={styles.buttonClearFilters}
                    startIcon={<Close />}
                    onClick={handleCleanFilters}
                  >
                    Limpar Filtros
                  </Button>
                </Box>
              </Grid>
            ) : null}
          </Grid>
        </Box>
        <Grid>
          <Button
            startIcon={<Add />}
            onClick={handleNewOpen}
            sx={styles.button}
            variant="contained"
          >
            Novo Usuário
          </Button>
        </Grid>
      </Box>
      <ModalFiltersMobile
        openModal={openMobileModal}
        setOpenMobileModal={setOpenMobileModal}
        verifyStatus={verifyStatus}
        setVerifyStatus={setVerifyStatus}
        permissionStatus={permissionStatus}
        setPermissionStatus={setPermissionStatus}
      />
      <Tooltip title="Adicionar filtros">
        <Button
          sx={styles.buttonFilterMobile}
          onClick={() => setOpenMobileModal(true)}
          variant="contained"
        >
          <FilterAltOutlined sx={styles.size} />
          <Badge badgeContent={filtersCount} sx={styles.badge} />
        </Button>
      </Tooltip>
    </>
  );
};

export default Filters;
